import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { JourneyTypeListResponseData } from "../../types/enum";

export const getData = async () => {
  const { data } = await api.get<JourneyTypeListResponseData>(`/journey-types`);

  return data;
};

export const useJourneyTypes =
  (): QueryObserverBaseResult<JourneyTypeListResponseData> => {
    const { data, ...props } = useQuery(queryKeys.journeyTypes(), () =>
      getData(),
    );

    return { data, ...props };
  };
